<template>
	<section class="b360-grid-row">
		<cloudinary-uploader
			:label="'Profile Photo'"
			:id="'create-partner'"
			@upload="uploadPartnerPhoto"
			@delete="deletePartnerPhoto"
			:uri="partner.partnerImage.imageUri"
			class="b360-col-12 b360-col-md-4 b360-col-sm-12"
		/>
		<section class="b360-col-12 b360-col-md-8 b360-grid-row">
			<form-inputs
				class="b360-col-12 b360-col-md-6"
				id="partner-name"
				:name="'name'"
				label="Partner Name"
				type="text"
				placeholder="ex. John Smith"
				pattern="input.pattern"
				:required="true"
				v-model="partner.name"
				@handle-input="updatePartnerDetails"
			/>
			<form-inputs
				class="b360-col-12 b360-col-md-6"
				id="company"
				:name="'companyName'"
				label="Company"
				type="text"
				placeholder="ex. Company Name"
				pattern="input.pattern"
				:required="true"
				v-model="partner.companyName"
				@handle-input="updatePartnerDetails"
			/>
			<form-inputs
				class="b360-col-12 b360-col-md-6"
				id="address1"
				:name="'addressLine1'"
				label="Address 1"
				type="text"
				placeholder="ex. 123 Main St."
				pattern="input.pattern"
				:required="true"
				v-model="partner.addressLine1"
				@handle-input="updatePartnerDetails"
			/>
			<form-inputs
				class="b360-col-12 b360-col-md-6"
				id="address2"
				:name="'addressLine2'"
				label="Address 2"
				type="text"
				placeholder="ex. Suite 101"
				pattern="input.pattern"
				v-model="partner.addressLine2"
				@handle-input="updatePartnerDetails"
			/>
			<form-inputs
				class="b360-col-12 b360-col-md-6"
				id="city"
				:name="'city'"
				label="City"
				type="text"
				placeholder="ex. Suite 101"
				pattern="input.pattern"
				:required="true"
				v-model="partner.city"
				@handle-input="updatePartnerDetails"
			/>
			<state-dropdown
				:name="'state'"
				:label="'State'"
				:required="true"
				:options="selectStatesArray"
				class="b360-col-12 b360-col-md-6"
				v-model="partner.state"
				@input="updatePartnerDetails"
			></state-dropdown>
			<form-inputs
				class="b360-col-12 b360-col-md-6"
				id="postal-code"
				:name="'zipCode'"
				label="Postal Code"
				type="text"
				placeholder="ex. 48204"
				pattern="input.pattern"
				:required="true"
				v-model="partner.zipCode"
				@handle-input="updatePartnerDetails"
			/>
			<form-inputs
				class="b360-col-12 b360-col-md-6"
				id="phone-number"
				:name="'phoneNumber'"
				label="Phone Number"
				type="phone"
				placeholder="ex. 313-555-1234"
				:pattern="'\d{3}[\-]\d{3}[\-]\d{4}'"
				:required="true"
				:mask="[
					/[1-9]/,
					/\d/,
					/\d/,
					'-',
					/\d/,
					/\d/,
					/\d/,
					'-',
					/\d/,
					/\d/,
					/\d/,
					/\d/,
				]"
				v-model="partner.phoneNumber"
				@handle-input="updatePartnerDetails"
			/>
			<form-inputs
				class="b360-col-12 b360-col-md-6"
				id="email"
				:name="'emailAddress'"
				label="Email Address"
				type="email"
				placeholder="ex. jsmith@achmemortgage.com"
				:required="true"
				v-model="partner.emailAddress"
				@handle-input="updatePartnerDetails"
			/>
			<form-inputs
				class="b360-col-12 b360-col-md-6"
				id="website"
				:name="'websiteUrl'"
				label="Website"
				type="text"
				placeholder="ex. jsmith@achmemortgage.com"
				pattern="input.pattern"
				:required="true"
				v-model="partner.websiteUrl"
				@handle-input="updatePartnerDetails"
			/>
		</section>
	</section>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import CloudinaryUploader from '@/components/preference-center/CloudinaryUploader.vue';
import FormInputs from '@/components/global/FormInputs.vue';
import StateDropdown from '@/components/preference-center/StateDropdowns.vue';

export default {
	name: 'partnersModal',
	components: {
		CloudinaryUploader,
		FormInputs,
		StateDropdown,
	},
	data() {
		return {};
	},
	computed: mapState({
		selectStatesArray: (state) => state.partners.americanStates,
		partner: (state) => state.partners.newPartner,
	}),
	methods: {
		...mapActions([
			'americanStates',
			'updatePartner',
			'createPartner',
			'uploadPartnerPhoto',
			'deletePartnerPhoto',
			'updatePartnerDetails',
		]),
	},
};
</script>

<style lang="scss" scoped>
.b360-grid-row {
	grid-gap: 1.25rem; //20px
}
</style>
